import axios from "axios";
import { stringify } from "qs";
import baseConfig from "../baseConfig/config";
// import { requestErrorMonitor } from "../utils/monitor";

const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  408: "请求失败了",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。"
};

/**
 * get http request api full url
 * @param {*} url 
 * @returns 
 */
const getFullUrl = (url) => {
  if (url.indexOf("http://") != -1 || url.indexOf("https://") != -1) {
    return url;
  }
  url = baseConfig.betApi() + url;
  return url;
}

/**
 * check token error 
 * notice: 这个是充值项目所以必须是登录状态的，所以不用过滤非登录状态情况 
 * @param {*} response 
 * @returns 
 */
const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
      let state = response.data && (response.data.result == 9 || response.data.result == 104 || response.data.result == 105 || response.data.result == 1007); 
      if (state) {

      }
      return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

/**
 * 执行 post 请求, 请求体为 JSON
 * @param {JSON} requestConfig 请求参数
 * {
 *    url:"/view/a/b/xxxxx",
 *    params: {
 *      var1:"var1"
 *      ...
 *    },
 *    headers: {}, // headers
 *    timeout: 15000, //超时时长,单位毫秒
 *    config:{  // axios config
 *      ...
 *    }
 * }
 */
export function postJson(requestConfig) {
  const options = {
      method: "post",
      data: typeof requestConfig.params != "string" ? JSON.stringify(requestConfig.params) : requestConfig.params, //将对象转换为JSON字符串
      headers: requestConfig.headers || {
        "Content-Type": "application/json; charset=utf-8"
      },
      url: getFullUrl(requestConfig.url),
      timeout: requestConfig.timeout || baseConfig.defaultTimeout
  };
  return request(options);
}

/**
 * 执行 post from表单 请求, 请求方式为 form 表单提交
 * @param {JSON} requestConfig 请求参数
 *
 */
export function postForm(requestConfig) {
  const dataParams = stringify(requestConfig.params); //将对象转换为 key1=val1&key2=val2 格式
  const options = {
    method: "post",
    data: dataParams,
    headers: requestConfig.headers || {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
    },
    url: getFullUrl(requestConfig.url),
    timeout: requestConfig.timeout || baseConfig.defaultTimeout,
  };
  // 处理文件下载操作
  if(requestConfig.responseType) options.responseType = requestConfig.responseType;
  return request(options);
}

/**
 * 执行 get 请求
 * @param {JSON} requestConfig 请求参数
 *
 */
export function get(requestConfig) {
  const options = {
    method: "get",
    headers: requestConfig.headers || {
      Accept: "application/json"
      // "Content-Type": "application/json"
    },
    params: requestConfig.params,
    url: getFullUrl(requestConfig.url),
    timeout: requestConfig.timeout
  };
  // 处理文件下载操作
  if(requestConfig.responseType) options.responseType = requestConfig.responseType;
  return request(options);
}

//处理info
function replaceInfoMessage(data) {
  let {info,arrs} = data
  if (Array.isArray(arrs) && typeof(info)=='string') {
    arrs.forEach(e=>{
      info = info.replace("%s", e)
    })
    data.info = info
  }
  return data
}
/**
 * Requests a URL, returning a promise.
 *
 * @param  {object} [option] The options we want to pass to "axios.request"
 * @return {object}           An object containing either "data" or "err"
 */
export function request(option) {
  !window.tryCounter && (window.tryCounter = {});
  // console.log(option);
  // console.log("request url = %s,  params = %o", option.url, option.data);
  const options = {
    ...option
  };

  const defaultOptions = {
    // credentials: 'include',
    // timeout: httpBaseConfig.timeout
  };
  const newOptions = {
    ...defaultOptions,
    ...options
  };
  if (
    newOptions.method === "post" ||
    newOptions.method === "put" ||
    newOptions.method === "delete"
  ) {
    // newOptions.headers = {
    //   // Accept: "application/json",
    //   ...newOptions.headers
    // };
  }
  // console.log("newOptions = ", newOptions);
  return (
    axios
      .request(newOptions)
      .then(checkStatus)
      .then(response => {
        window.tryCounter[option.url] && (delete window.tryCounter[option.url]);
        return response.data;
      })
      .then(response => {
        window.tryCounter[option.url] && (delete window.tryCounter[option.url]);
        return replaceInfoMessage(response)
      })
      .catch(error => {
        console.log("request error = ", error);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log("error.response.data = ", error.response.data);
          console.log("error.response.status = ", error.response.status);
          console.log("error.response.headers = ", error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log("error.request = ", error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("error.message = ", error.message);
        }
        console.log("error.config = ", error.config);
        // requestErrorMonitor(error, newOptions);
        !window.tryCounter[option.url] && (window.tryCounter[option.url] = 0);
        window.tryCounter[option.url]++;
        if (window.tryCounter[option.url] < 3) {
            return request(option);
        }
      })
  );
}



// WEBPACK FOOTER //
// ./src/server/request.js